import React from 'react';
import ConsultantTicketListContainer from '../ConsultantTicketList/ConsultantTicketListContainer';
import * as ROUTES from '../../lib/routing/frontend';

// The broadcast list reuses the shared ticket list container.
// suppressDefaultTypeFilter prevents injecting the non-broadcast type codes — the broadcast
// type filter is already supplied via defaultFilters on the route in Routes.js.
// paginationRoute ensures pagination links point to the broadcasts URL, not the tickets URL.
const ConsultantBroadcastListContainer = (props) => (
  <ConsultantTicketListContainer
    {...props}
    paginationRoute={ROUTES.CONSULTANT_TICKETS.ALL_BROADCASTS}
    suppressDefaultTypeFilter={true}
  />
);

export default ConsultantBroadcastListContainer;
